import { render, staticRenderFns } from "./ordersListTableL.vue?vue&type=template&id=12fcb1e2&scoped=true"
import script from "./ordersListTableL.vue?vue&type=script&lang=js"
export * from "./ordersListTableL.vue?vue&type=script&lang=js"
import style0 from "./ordersListTableL.vue?vue&type=style&index=0&id=12fcb1e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fcb1e2",
  null
  
)

export default component.exports